<template lang="pug">
  Icon.icon(name="notification-lightning" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Срок задачи
    Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
    |  в проекте
    Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
    |  истекает {{ item.info.period }}
</template>

<script>
export default {
  name: 'NotificationTaskTime',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
